module.exports = __webpack_public_path__ + "img/quanty.eedb3c10.png";